module.exports = __webpack_public_path__ + "fonts/baronsans-mediumitalic-webfont.f1d092f7.woff";